// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__G2tn0","contained":"OpenButton_contained__2q1kJ","disabled":"OpenButton_disabled__1SlAE","error":"OpenButton_error__2aZ0i"};